<script>
    /**
 *
 *
 *
 */

    /*                */
    let { image, lazyLoad = false } = $props();

    const TILE_PORTRAIT_PRESET = "$tile_portrait$";
    const MEDIUM_IMAGE_SIZE_PRESET = "$spa_ambiente$";
    const loadingValue = lazyLoad ? "lazy" : "eager";

    const isCutoutFriendlyBackground = $derived(["WHITE", "OTHERS"].includes(image.background) || !image.background);
    const isCutout = $derived(image.clippingType === "FREIGESTELLT" && isCutoutFriendlyBackground);
    const isAmbiente = $derived(image.clippingType === "AMBIENTE");
    const showOverlay = $derived(isCutout || isAmbiente);

    const buildImageUrl = (imageUrl) => {
        if (isAmbiente) {
            return imageUrl + "?" + MEDIUM_IMAGE_SIZE_PRESET;
        }
        return isCutout ? imageUrl + "?" + TILE_PORTRAIT_PRESET + "&w=96&h=96" : imageUrl + "?";
    };

    const imageSrc = $derived(buildImageUrl(image._links.external.href));
</script>

<div class="reco_simple_cinema__image" style:max-height={`96px`} style:aspect-ratio="1 / 1">
    <picture>
        <source srcset="{imageSrc}&fmt=auto" />
        <img
            loading={loadingValue}
            data-src={imageSrc}
            src={lazyLoad ? "" : imageSrc}
            alt={image.altText}
            class="{lazyLoad ? 'lazy' : ''} {isCutout ? 'cutout' : 'ambiente'}"
            data-testid="image-title"
        />
    </picture>
    {#if showOverlay}
        <div data-testid="simple-cutout-overlay" class="reco_cinema__simple_cutout_overlay"></div>
    {/if}
    <div class="reco_simple_cinema__image__spinner_box">
        <div data-testid="image-spinner" class="reco_simple_cinema__image__spinner {lazyLoad ? 'p_loader250' : ''}"></div>
    </div>
</div>

<style lang="scss">.reco_simple_cinema__image {
  text-align: center;
  padding-bottom: initial;
  position: relative;
  overflow: hidden;
  max-height: 100%;
  max-width: 100%;
}
.reco_simple_cinema__image img {
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  right: 50%;
  transform: translate(50%, 0);
}
.reco_simple_cinema__image img.ambiente {
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
  max-width: none;
  object-fit: cover;
}
.reco_simple_cinema__image img.cutout {
  padding: 10%;
  width: 100%;
  object-fit: contain;
}

.reco_simple_cinema__image__spinner_box {
  position: absolute;
  margin: auto;
  width: 60px;
  height: 60px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: -1;
}

.reco_cinema__simple_cutout_overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(33, 33, 33, 0.06);
  pointer-events: none;
}</style>
